import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      margin: "1.5rem",
    },
    card: {
      borderRadius: 16,
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
      border: "1px solid #eef0f3",
      overflow: "hidden",
    },
    cardHeader: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "16px 24px",
      backgroundColor: "#f8fafc",
      borderBottom: "1px solid #eef0f3",
    },
    cardHeaderIcon: {
      width: 44,
      height: 44,
      borderRadius: 12,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(17, 98, 254, 0.1)",
      color: "#1162FE",
    },
    cardTitle: {
      fontSize: "1.15rem",
      fontWeight: 700,
      color: "#1f2937",
    },
    labelContainer: {
      marginBottom: "10px",
    },
    headingLabel: {
      fontSize: "1.6rem",
    },
    profileImageContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      margin: "0.5rem",
    },
    profileImageError: {
      height: "100px",
      width: "100px",
      borderRadius: "100%",
      border: "3px solid #eef0f3",
      textAlign: "center",
    },
    profileImage: {
      height: "100px",
      width: "100px",
      borderRadius: "100%",
      objectFit: "cover",
      "&:hover": {
        cursor: "pointer",
      },
      border: "3px solid #eef0f3",
    },
    imageErrorContainer: {
      marginTop: "5px",
    },
    imageError: {
      fontSize: "0.75rem",
      color: "red",
    },
    formContainer: {
      padding: "1.5rem 2rem 2rem",
    },
    saveButtonContainer: {
      width: "10%",
      textAlign: "right",
      padding: "10px 0",
      fontSize: "16px",
      fontWeight: "bold",
      borderRadius: "8px",
      marginTop: "16px",
    },
    editIcon: {
      position: "absolute",
      bottom: "1px",
      right: "-5px",
      border: "1px solid rgba(0, 0, 0, 0.2)",
      borderRadius: "50%",
      height: "35px",
      width: "35px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#fff",
      "&:hover": {
        cursor: "pointer",
      },
    },
    uploadContainer: {
      position: "relative",
    },
  };
});
